import { render, staticRenderFns } from "./batchupload.vue?vue&type=template&id=c245e21e&scoped=true"
import script from "./batchupload.vue?vue&type=script&lang=js"
export * from "./batchupload.vue?vue&type=script&lang=js"
import style0 from "./batchupload.vue?vue&type=style&index=0&id=c245e21e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c245e21e",
  null
  
)

export default component.exports